import { createContext, useContext, useState, useEffect, useCallback, useMemo } from 'react';
import useAxios from '@/hooks/use-axios';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const api = useAxios();

  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(false);

  const isAuthenticated = useMemo(() => {
    const token = localStorage.getItem('user_token');
    return !!token;
  });

  const logout = useCallback(() => {
    localStorage.removeItem('user_token');
    setUserData(null);
  }, []);

  useEffect(() => {
    if (isAuthenticated && !userData && !loading) {
      setLoading(true);
      api
        .get('/user/me')
        .then((res) => {
          setUserData(res.data);
        })
        .catch((err) => {
          console.error('Failed to fetch user:', err);
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [isAuthenticated]);

  return (
    <AuthContext.Provider value={{ isAuthenticated, userData, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

// custom hook
export const useAuth = () => {
  return useContext(AuthContext);
};
